import Component from '@glimmer/component';
import { PrismCard } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import SettingsMappingHierarchyCategoryItemBenchmark from 'lumen/components/settings/mapping/hierarchy/category-item-benchmark';

interface SettingsMappingHierarchyMappingHierarchyBenchmarkSignature {
  Args: {
    rootCategory: unknown;
  };
}

export default class SettingsMappingHierarchyMappingHierarchyBenchmark extends Component<SettingsMappingHierarchyMappingHierarchyBenchmarkSignature> {
  HIERARCHY_ITEM_TYPE_CATEGORY = 'category';

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hierarchyItems() {
    // @ts-expect-error: Incorrect type
    const hierarchyItems = [];
    if (this.args.rootCategory) {
      // @ts-expect-error: Incorrect type
      this.flattenCategories(hierarchyItems, this.args.rootCategory);
    }
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return hierarchyItems;
  }

  // Creates a flat list with all the categories and children in order
  // @ts-expect-error: Incorrect type
  flattenCategories(hierarchyItems, category): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!category.isRootCategory) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      hierarchyItems.push({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        category,
        type: this.HIERARCHY_ITEM_TYPE_CATEGORY,
      });
    }

    // Recursively add child categories
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (category.isExpanded) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      category.childrenSorted.forEach((childCategory) =>
        this.flattenCategories(hierarchyItems, childCategory),
      );
    }
  }

  <template>
    <PrismCard
      @contentLayout="noPadding"
      class="text-200--regular mapping-hierarchy"
    >
      <:header as |Header|>
        <Header.title class="ic-product-tour-mapping-hierarchy-title">
          {{t "settings.pms_mapping.hierarchy"}}
        </Header.title>
      </:header>
      <:content>
        <div class="mapping-hierarchy__content">
          {{#each this.hierarchyItems as |hierarchyItem|}}
            <SettingsMappingHierarchyCategoryItemBenchmark
              @category={{hierarchyItem.category}}
            />
          {{/each}}
        </div>
      </:content>
    </PrismCard>
  </template>
}
